<template>
  <div>
    <ca-heading text="Trabalhistas" size="medium"></ca-heading>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Tipo de regime trabalhista">
          {{ jobInfo.workingType.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Tipo de regime previdenciário">
          {{ jobInfo.pensionType.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Aposentadoria Especial">
          {{ jobInfo.agentExposureType.description }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Regime de jornada">
          {{ jobInfo.workingHoursType.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Natureza da atividade">
          {{ jobInfo.natureActivityWork.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Data base da categoria">
          {{ jobInfo.baseDate }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="4">
        <ca-field label="Categoria">
          {{ jobInfo.category.description }}
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Vínculo com outra empresa">
          {{ jobInfo.anotherCompanyInformation.description }}
        </ca-field>
      </ca-col>
      <ca-col v-if="jobInfo.anotherCompanyInformation.valor !== 'S'" size="4">
        <ca-field label="CNPJ da outra empresa">
          {{ jobInfo.anotherCompanyRegistration }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col v-if="jobInfo.anotherCompanySalary" size="4">
        <ca-field
          v-if="jobInfo.anotherCompanySalary.valor !== 'S'"
          label="Remuneração na outra empresa">
          {{ `R$ ${jobInfo.anotherCompanySalary}` }}
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>

export default {
  name: 'WorkerJobInfo',
  props: {
    jobInfo: Object,
    worker: Object,
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    onEdit() {
      this.$router.push({
        name: 'WorkerJobInfoForm',
        params: {
          id: this.$route.params.id,
          name: this.worker.name,
        },
      });
    },
  },
};
</script>
